import {
  DEFAULT_CURRENCY_CODE,
  InjectionToken,
  LOCALE_ID,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { IAppConfig, IEnv } from '@tnq/shared/types';
import localeNl from '@angular/common/locales/nl';

export const ENV: InjectionToken<IEnv> = new InjectionToken('env');
export const CONFIG: InjectionToken<IAppConfig> = new InjectionToken('config');

registerLocaleData(localeNl, 'nl-NL');

@NgModule({
  imports: [CommonModule],
})
export class SharedConfigModule {
  public static register({
    env,
    config,
  }: {
    env: IEnv;
    config?: IAppConfig;
  }): ModuleWithProviders<SharedConfigModule> {
    return {
      ngModule: SharedConfigModule,
      providers: [
        { provide: ENV, useValue: env },
        { provide: CONFIG, useValue: config },
        {
          provide: LOCALE_ID,
          useValue: 'nl-NL',
        },
        {
          provide: DEFAULT_CURRENCY_CODE,
          useValue: 'EUR',
        },
      ],
    };
  }
}
